import React, { useContext } from 'react';
import AppContext from '../../context/app/appContext';
import Parser from 'html-react-parser';

const NoResult = () => {

  const appContext = useContext(AppContext);
  const { translations } = appContext;

  return (
    <div className="js-component-archive-result component-archive-result row">
      <div className="col-12 col-sm-10 col-md-6 mx-auto entry-content text-center">
        <p className="preamble">{Parser(translations.noResult)}</p>
      </div>
    </div>
  );
};

export default NoResult;



// WEBPACK FOOTER //
// ./src/components/Posts/NoResult.js